import React from 'react';
import { Avatar, Card, Table, Progress, Typography, Col, Space } from 'antd';
import Logo from "../../../components/Graphics/Logo";
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import MorningstarStylebox from "../../../components/Stylebox/MorningstarStylebox";
import {iconMapping} from "../../../configs/AppsConfig";
import {stringMixin} from "../../../utils/strings";
import TickerChip  from "../../../components/TickerChip";
import {DoubleLine} from "../../../components/Labels";
import useClipboard from "../../../hooks/useClipboard";
import {Copy} from 'lucide-react'
const { Title } = Typography;


export const colorTableRow = (record, rowIndex) => {
    const color = record?.weight > 0 ? '#BCFFEC' : '#EBD5D5';
    return {
        style: {
            background: `linear-gradient(to right, ${color} 5px, #fff 5px)`,
            zIndex: 100000,
        }
    }
}


const tableColumns = [
    {
      title: 'Portfolio Holding',
      dataIndex: 'logo',
      key: 'logo',
      render: (text, record)=><TickerChip ticker={record} />
    },
    {
      title: 'Weight (%)',
      dataIndex: 'weight',
      key: 'weight',
      render: weight => <Progress
          type={'dashboard'}
          size={[50, 30]}
          percent={parseFloat((weight).toFixed(1))}
          status="active"
      />, // This assumes `weight` is a percentage value.
    },
    {
        title: "Corr S&P (1Y)",
        dataIndex:  ['stats', 'benchmarks', 'spy', 'corr_1_yr'],
        key: 'corr',
        render: (text)=>stringMixin.pct(text),
        sorter: (a, b) => a?.stats?.benchmarks?.spy?.corr_1_yr - b?.stats?.benchmarks?.spy?.corr_1_yr,
        width: 150,
        align: 'center',
        className: 'bold'
    },
    {
        title: "Categories",
        dataIndex: 'categories',
        key: 'categories',
        render: (text, record)=><DoubleLine title={record?.tags?.sector} text={record?.tags?.industry}/>
    },
    {
      title: "Stylebox",
      render: (record)=> {
          const size = record?.tags?.size;
          const style = record?.tags?.style;
          if (size && style) {
              return <MorningstarStylebox styles={[`${size}_${style}`]} showLabels={false} />
          }
          return '';
      },
      align: 'center'
    }
];


const TickerTable = ({ tickers }) => {
    tickers.sort((a, b) => b.weight - a.weight);
    const copyToClipboard = useClipboard();
    const etfTickers = tickers.filter(ticker => ticker.type === 'etf');

  return (
      <Card
        bordered={false}
        title={<Typography.Title level={3}>Portfolio Composition</Typography.Title>}
        extra={
          <Space  className={'py-3'}>
              <ButtonGroup>
                  <Button onClick={()=>copyToClipboard(JSON.stringify(tickers.map(x=>x.symbol)))}>
                      <Copy/>
                  </Button>
              </ButtonGroup>
              <ButtonGroup>

                    <Button
                            variant={'contained'}
                            onClick={()=>window.open(`/public/etfs/matrix?etfs=${etfTickers.map(x=>x.symbol).join(',')}`)}
                            startIcon={<Avatar className={'mx-1 mb-1'} src={iconMapping.positions}/>}
                            color={'primary'}
                            size={'small'}
                    >
                        View ETF Matrix
                    </Button>
                    <Button variant={'outlined'}
                            startIcon={<Avatar className={'mx-1 mb-1'} src={iconMapping.performanceComparison}/>}
                            size={'small'}
                            onClick={()=>window.open(`/public/beta/comparison?tickers=${tickers.map(x=>x.symbol).join(',')}`)}

                    >
                        Compare ({tickers.length}) Tickers
                    </Button>
              </ButtonGroup>

          </Space>
      }
      >
          <Table
              columns={tableColumns}
              dataSource={tickers}
              rowKey="symbol"
              className={'nowrap-headers'}
              pagination={false} // Disable pagination if not needed
              scroll={{ x: true, y: 800 }} // Makes table scrollable horizontally
            />
      </Card>
  )

};

export default TickerTable;